<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="part1"></a><a id="page_1">
<p class="chaptertitle" id="chap_p64"><b>ONE</b></p>
</a></div><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?d8193d30